var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// https://stackoverflow.com/a/6860916/2570866
export function generateRandomId() {
    // prettier-ignore
    return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}
function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}
export function dataTransferItemsHaveFiles(items) {
    if (!items || !items.length) {
        return false;
    }
    for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
        var item = items_1[_i];
        if (item.kind === 'file' || item.type === 'text/html') {
            return true;
        }
    }
    return false;
}
function getFileLikes(items) {
    var fileLikes = [];
    for (var _i = 0, items_2 = items; _i < items_2.length; _i++) {
        var item = items_2[_i];
        if (item.kind === 'file') {
            var file = item.getAsFile();
            if (file) {
                fileLikes.push(file);
            }
        }
    }
    return fileLikes;
}
function getImageSource(fileLikes, src) {
    return __awaiter(this, void 0, void 0, function () {
        var res, e_1, contentType, buf, blob;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetch(src)];
                case 1:
                    res = _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    return [2 /*return*/];
                case 3:
                    contentType = res.headers.get('Content-type') || 'application/octet-stream';
                    return [4 /*yield*/, res.arrayBuffer()];
                case 4:
                    buf = _a.sent();
                    blob = new Blob([buf], { type: contentType });
                    fileLikes.push(blob);
                    return [2 /*return*/];
            }
        });
    });
}
var extractImageSources = function (s) {
    var imageTags = new DOMParser()
        .parseFromString(s, 'text/html')
        .getElementsByTagName('img');
    return Array.from(imageTags, function (tag) { return tag.src; }).filter(function (tag) { return tag; });
};
export function dataTransferItemsToFiles(items) {
    return __awaiter(this, void 0, void 0, function () {
        var fileLikes, blobPromises, _loop_1, _i, items_3, item;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!items || !items.length) {
                        return [2 /*return*/, []];
                    }
                    fileLikes = getFileLikes(items);
                    if (fileLikes.length) {
                        return [2 /*return*/, fileLikes];
                    }
                    blobPromises = [];
                    _loop_1 = function (item) {
                        if (item.type === 'text/html') {
                            blobPromises.push(new Promise(function (accept) {
                                item.getAsString(function (s) { return __awaiter(_this, void 0, void 0, function () {
                                    var imagePromises;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                imagePromises = extractImageSources(s).map(function (src) {
                                                    return getImageSource(fileLikes, src);
                                                });
                                                return [4 /*yield*/, Promise.all(imagePromises)];
                                            case 1:
                                                _a.sent();
                                                accept();
                                                return [2 /*return*/];
                                        }
                                    });
                                }); });
                            }));
                        }
                    };
                    for (_i = 0, items_3 = items; _i < items_3.length; _i++) {
                        item = items_3[_i];
                        _loop_1(item);
                    }
                    return [4 /*yield*/, Promise.all(blobPromises)];
                case 1:
                    _a.sent();
                    return [2 /*return*/, fileLikes];
            }
        });
    });
}
export var useHandleFileChangeWrapper = function (resetOnChange, handler) {
    if (resetOnChange === void 0) { resetOnChange = false; }
    return function (_a) {
        var currentTarget = _a.currentTarget;
        var files = currentTarget.files;
        if (!files)
            return;
        try {
            handler === null || handler === void 0 ? void 0 : handler(Array.from(files));
        }
        catch (error) {
            console.error(error);
        }
        if (resetOnChange)
            currentTarget.value = '';
    };
};
